import { Component, Input, OnInit } from '@angular/core';
import { BsLocaleService } from "ngx-bootstrap/datepicker";
import { esLocale } from "ngx-bootstrap/locale";
import { defineLocale } from "ngx-bootstrap/chronos";
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.css']
})
export class DatepickerComponent implements OnInit {
  
  @Input() control: FormControl;
  @Input() controlName: string;
  @Input() formRef: any;
  @Input() maxDate: boolean = true;

  bsConfig: any;
  today = new Date();
  

  constructor(private localeService: BsLocaleService) { 
    esLocale.weekdaysShort = ["D", "L", "M", "M", "J", "V", "S"];
    defineLocale("es", esLocale);
  }

  ngOnInit(): void {
    this.bsConfig = {
      showWeekNumbers: false, 
      maxDate: this.maxDate ? this.today : null,
      customTodayClass: 'today-class'
    }

    this.localeService.use("es");
  }

  onDateSelected(event) {
    const date = new Date(event._bsValue);
    this.control.setValue(date);
    if (!this.sameDate(date, this.today) && date.getTime() != 0) {
      this.bsConfig.customTodayClass = ''
    }
  }

  sameDate(aDate, anotherDate) {
    return (
      aDate.getDate() == anotherDate.getDate() &&
      aDate.getFullYear() == anotherDate.getFullYear() &&
      aDate.getMonth() == anotherDate.getMonth()
    )
  }

}
